import axios, { AxiosInstance } from "axios";
import * as Constants from "../../src/containers/pages/Constants/ConstantValues";
 
const iPAddress = Constants.IpAddress;
if (process.env.REACT_APP_API_URL) {
   
}


export class Http {
  public static axios(): AxiosInstance {
    return axios.create({
    baseURL: iPAddress+'/api2/'
    });
  }
}
export class HttpCase {
  public static axios(): AxiosInstance {
    return axios.create({
      baseURL: iPAddress+'/api3/'
    });
  }
}
export class HttpH1BForms {
  public static axios(): AxiosInstance {
    return axios.create({
     
      baseURL: iPAddress+'/api4/'
    });
  }
}
export class HttpEmpBiog {
  public static axios(): AxiosInstance {
    return axios.create({
     
      baseURL: iPAddress+'/api5/'
    });
  }
} 
export class HttpCaseFlowInitiation {
  public static axios(): AxiosInstance {
    return axios.create({
      baseURL: iPAddress+'/api6/'
    });
  }
}
export class HttpUpload {
  public static axios(): AxiosInstance {
    return axios.create({
     
      baseURL: iPAddress+'/api7/'
    });
  }
}
export class HttpFormType {
  public static axios(): AxiosInstance {
    return axios.create({
     
      baseURL: iPAddress+'/api8/'
    });
  }
}
export class HttpH4Forms {
  public static axios(): AxiosInstance {
    return axios.create({
     
      baseURL: iPAddress+'/api9/'
    });
  }
}
 
export class HttpEmail {
  public static axios(): AxiosInstance {
    return axios.create({
      baseURL: iPAddress+'/api10/'
    });
  }
}

export class HttpPayments {
  public static axios(): AxiosInstance {
    return axios.create({
     
      baseURL: iPAddress+'/api11/'
    });
  }
}

export class HttpNew {
  public static axios(): AxiosInstance {
    return axios.create({
         baseURL: ""
    });
  }
}

export class HttpUpcomingEvents {
  public static axios(): AxiosInstance {
    return axios.create({
     
      baseURL: iPAddress+'/api14/'
    });
  }
}

export class HttpEAD {
  public static axios(): AxiosInstance {
    return axios.create({
     
      baseURL: iPAddress+'/api15/'
    });
  }
}

export class HttpTemplates {
  public static axios(): AxiosInstance {
    return axios.create({
     
      baseURL: iPAddress+'/api16/'
    });
  }
}
export class HttpReports {
  public static axios(): AxiosInstance {
    return axios.create({
     
      baseURL: iPAddress+'/api17/'
    });
  }
}
export class HttpPaymentsLocal {
  public static axios(): AxiosInstance {
    return axios.create({
      baseURL: "http://localhost:8091/"
    });
  }
} 
export class HttpStipe {
  public static axios(): AxiosInstance {
    return axios.create({
      baseURL: "https://api.stripe.com/"
    });
  }
}

export class HttpStripe {
  public static axios(): AxiosInstance {
    return axios.create({
      baseURL: "https://api.stripe.com/"
    });
  }
}

export class HttpTestForm {
  public static axios(): AxiosInstance {
    return axios.create({
      baseURL: "https://account-d.docusign.com/" 
    });
  }
} 

export class HttpAPI {
  private static instance: AxiosInstance;

  public static axios(): AxiosInstance {
    if (!HttpAPI.instance) {
      HttpAPI.instance = axios.create({
        baseURL: "https://www.v-ehr.com/vehrApi/ehr/v1",
        headers: { "Content-Type": "application/json" },
      });

      HttpAPI.instance.interceptors.request.use((config) => {
        const token = sessionStorage.getItem("access_token");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      });
    }

    return HttpAPI.instance;
  }
}
export const apiURL = iPAddress+'/api2/api/';
export const caseURL = iPAddress+'/api3/';
export const caseInitiationURL = iPAddress+'/api4/';
export const caseUploadURL = iPAddress+'/api7/';
export const downloadURL = iPAddress+'/api2/visacare/';
export const formTypeURL = iPAddress+'/api8/';